import { useUserStore } from '@/store/user'
import { useExamFilterStore } from '@/store/examFilter';
import { watch } from 'vue'

import ExamFilter from '../exam/ExamFilter.vue'
import MenuProfile from './MenuProfile.vue'
//import MenuStorageBar from './MenuStorageBar.vue'
import Notifications from './Notifications.vue'
import PatientListSearchedOffcanvas from '../patient/PatientListSearchedOffcanvas.vue'

import profile_img from "@/assets/images/phelcom/profile_img.png";

export default {
  name: 'MenuMobileLinks',
  props: ['isResize'],
  components: {
    ExamFilter,
    MenuProfile,
//    MenuStorageBar,
    Notifications,
    PatientListSearchedOffcanvas
  },
  data: () => ({
    active: null,
    open: true,
    openNotif: false,
    allowSynchronization: true,
    isSpecialist: null,
    isPowerfull: null,
    session: {
      collaborator: {},
      currentClinic: {}
    },
    notificationData: {
      count: 0,
      events: []
    },
    notificationCount: 0,
    notification: [],
    appVersion: process.env.VUE_APP_VERSION,
    isPaid: true,
    isBackdropActive: false,
    isExpanded: false,
    isExamFilter: false,
    patientList: {},
    searchValue: '',
    locale: null,
    userTheme: 'light-theme',
    showLatestResults: false,
    showPatientSearchResults: false,
    showDateFilter: false,
    examFilter: null,
    // hasFilterItems: false,
    // patientFullName: '',
    debouncedSearch: null,
    searchMode: 'patient',
    isSmallScreen: false,
    examFilterStore: useExamFilterStore(),
    // currentFilter: {}
  }),
  watch: {
    '$activeLink.value': {
      handler: function () {
        this.active = this.$activeLink.value
    }, deep: true },
    'examFilterStore.filter.shouldCloseFilter': {
      handler(newValue) {
        if (!this.isSmallScreen)
          return

        if (newValue === true) {
          this.clearSearch()
          this.examFilterStore.refreshFilter({ shouldCloseFilter: false })
        }
      },
      immediate: false,
      deep: true
    }
  },
  computed: {
    avatar() {
      return this.session.userPhoto ? this.session.userPhoto : profile_img;
    },
    isExamRoute() {
      return this.$router.currentRoute.value.name === 'exam-list'
    },
    helpcenterUrl() {
      if (this.locale == 'pt-br')
        return 'https://phelcom.com/pt-br/helpcenter/'
      return 'https://phelcom.com/helpcenter/'
    },
    currentFilter() {
      return this.examFilterStore.filter.filter;
    },
    patientFullName() {
      return this.examFilterStore.filter.filter.patientFullName || '';
    },
    hasFilterItems() {
      const newInnerFilter = this.examFilterStore.filter.filter;
      const hasDateFilters = newInnerFilter.startDate || newInnerFilter.endDate;
      const hasPropertiesFilters = newInnerFilter.properties && Object.keys(newInnerFilter.properties).some(key =>
        (key !== 'startDate' && key !== 'endDate' && typeof newInnerFilter.properties[key] === 'boolean' && newInnerFilter.properties[key] === true)
      );

      const hasFfsFilter = newInnerFilter.ffsFilter && newInnerFilter.ffsFilter !== 'all';
      const hasReportStatusFilter = newInnerFilter.reportStatusFilter && newInnerFilter.reportStatusFilter !== 'all';

      if (newInnerFilter.patientID || hasDateFilters || hasPropertiesFilters || hasFfsFilter || hasReportStatusFilter) {
        document.body.classList.add('has-filter');
      } else {
        document.body.classList.remove('has-filter');
      }

      return !!(
        newInnerFilter.patientID ||
        hasDateFilters ||
        hasPropertiesFilters ||
        hasFfsFilter ||
        hasReportStatusFilter
      );
    },
  },
  mounted() {
    const userStore = useUserStore()

    this.session = userStore.sessionInfo
    this.currentClinicID = this.session.currentClinic.id
    this.isSpecialist = this.session.isSpecialist
    this.isPowerfull = this.session.isPowerfull
    this.active = this.$activeLink.value ? this.$activeLink.value : null
    this.locale = this.session.currentClinic.locale.toLowerCase()
    this.allowSynchronization = this.session.currentClinic.synchronizePatientData

    if (this.allowSynchronization == undefined)
      this.allowSynchronization = true

    this.$nextTick(() => {
      this.reloadNotifications()
    })
    // called from notificationService (logic is there)
    this.emitter.on("newNotification", event => {
      this.notification.push(event)
      this.notificationCount += 1 // view logic
    })

    const initUserTheme = this.getTheme() || this.getMediaPreference()
    this.setTheme(initUserTheme)

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.debouncedSearch = _.debounce(this.fetchPatients, 300);
  },
  methods: {
    handleResize() {
      this.isSmallScreen = window.innerWidth < 992;
    },
    profileMenu() {
      this.session.activeLink = 'users'
      this.$router.push(`/user/${this.session.user.id}`)
    },
    dashboardMenu(useRouter) {
      this.goToLink(this, 'dashboard', 'dashboard')
    },
    examMenu() {
      const examFilterStore = useExamFilterStore()

      this.session.examCurrentPage = 1
      examFilterStore.reset()
      sessionStorage.removeItem('examFilters')

      this.goToLink(this, 'exam', 'exam-list')
    },
    patientMenu() {
      this.session.patientCurrentPage = 1
      this.goToLink(this, 'patient', 'patient-list')
    },
    settingsMenu() {
      this.goToLink(this, 'settings', 'settings')
    },
    toggleMenu(val) {
      this.open = val
      console.log('veio do emit', val);
    },
    async logout() {
      await this.$authService.logout(this)
      window.open('/', '_self');
    },
    goToLink(self, active, link) {
      this.toggleMenu(false);
      self.active = active
      self.$router.push({name: 'proxy-router', params: {
        target: link,
        data: JSON.stringify({})
      }})
    },
    backofficeMenu() {
     const IS_PRODUCTION = process.env.NODE_ENV == 'production'
     let BASE_URL = 'http://bo2.eyercloud.com/'
     if (!IS_PRODUCTION){
        BASE_URL = 'http://devbo2.eyercloud.com/'
      }
      window.location = `${BASE_URL}`
    },
    reloadNotifications() {
      if (!this.currentClinicID)
        return
      const clinicData = this.$notificationService.reloadNotifications(this.currentClinicID)
      for (let e of clinicData.events) {
        this.addNotification(e)
      }
      this.notificationCount = clinicData.count
    },
    // bell icon clicked
    resetNotifications() {
      this.notificationCount = 0
      this.$notificationService.resetCount(this.currentClinicID)
      this.$notificationService.enable() // force notification activation
    },
    addNotification(data) {
      try {
        this.notification.unshift(data)
      } catch (e) {
        console.log('error(addNotification)', e);
      }
    },
    notificationClicked: async function(examid) {
      try {
        let params = {
          id: examid,
        }
        let response = await this.$examService.get(params);
        let data = this.$utils.dataQuery({
          exam: JSON.stringify(response.exam)
        })
        this.$router.push({name: 'exam-show', params: {examID: examid}, query: {tab: 'images', data: data}})
        // this.$router.push({name: 'proxy-router', params:{
        //   target: 'exam-show', data: {exam: response.exam, tab: null, examid: examid}
        // }})
      } catch(err) {
        this.alert = {
          message: `${this.$i18n.t('request_error')} <strong>${err}</strong>`,
          class: 'alert-danger'
        }
      }
    },
    doSearch() {
      this.debouncedSearch(this.searchValue);
    },
    async fetchPatients(partialName) {
      this.showLatestResults = false
      this.showPatientSearchResults = true
      this.showDateFilter = false

      if (!partialName || partialName.length < 3) {
        this.patientList = {};
        return;
      }

      this.loading = true;
      NProgress.start();
      try {
        const params = { partialName };
        const response = await this.$patientService.searchPatient(params);
        this.patientList = response.result || {};
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error');
        // this.alert = this.$message.alert(this, 'request_error', 'danger');
      } finally {
        NProgress.done(true);
        this.loading = false;
      }
    },

    toPatientDetails(item) {
      this.searchValue = ''
      this.patientList = {}
      this.$router.push({name: 'patient-show', params: {patientID: item.id}, query: {tab: 'data'}})
    },
    toExamDetails(event, item) {
      event.stopPropagation()
      let data = null
      this.searchValue = ''
      this.patientList = {}
      //this.$router.push({name: 'patient-show', params: {patientID: item.id}, query: {tab: 'data'}})
      this.$router.push({ name: 'exam-show', params: { examID: item.id }, query: { tab: 'images', data: data } })
    },
    toggleExamFilter() {
      this.showDateFilter = false
      this.searchMode = 'patient'
      this.isExpanded = false
      this.clearSearch()
    },
    toggleTheme() {
      if (!this.isSmallScreen)
        return

      const activeTheme = localStorage.getItem('user-theme');
      if (activeTheme === 'light-theme') {
        this.setTheme('dark-theme');
      } else {
        this.setTheme('light-theme');
      }
    },
    getTheme() {
      return localStorage.getItem('user-theme');
    },
    setTheme(theme) {
      localStorage.setItem('user-theme', theme);
      this.userTheme = theme;
      document.documentElement.className = theme;
    },
    getMediaPreference() {
      const hasDarkPreference = window.matchMedia(
        '(prefers-color-scheme: dark)'
      ).matches;
      if (hasDarkPreference) {
        return 'dark-theme';
      } else {
        return 'light-theme';
      }
    },
    formatDate(date) {
      return moment(date).format(this.$i18n.t('dateTimeFormat'))
    },
    updateExamFilter(payload) {
      const examFilterStore = useExamFilterStore();
      const currentInnerFilter = examFilterStore.filter.filter;

      const mergedFilter = {
        ...currentInnerFilter,
        ...payload.filter
      };

      const finalPayload = {
        ...payload,
        filter: mergedFilter
      };

      examFilterStore.refreshFilter(finalPayload);

      this.clearSearch()

      sessionStorage.setItem('examFilters', JSON.stringify(examFilterStore.filter))
      this.$router.push('/exam/')
    },
    doFilterExamListByPatientID(item) {
      this.showPatientSearchResults = false
      this.showDateFilter = false
      this.showLatestResults = false
      this.searchValue = ''
      this.patientList = {}

      this.$nextTick(() => {
        this.updateExamFilter({
          filter: {
            patientID: item.id,
            patientFullName: item.fullName
           },
          newRequest: true
        });
      })
    },
    doFilterExamListLastSevenDays() {
      const startDate = moment().subtract(7, 'days').toDate();
      const endDate = moment().toDate();

      const currentFilter = this.examFilterStore.filter.filter;

      const payloadFilter = {
        ...currentFilter,
        startDate: this.$utils.formatDate(this, startDate),
        endDate: this.$utils.formatDate(this, endDate)
      };

      this.updateExamFilter({
        filter: payloadFilter,
        newRequest: true
      });
    },
    // doFilterExamListByEyerMaps() {
    //   this.updateExamFilter({ eyerMaps: true });
    // },
    clearFilteredList(filterKey) {
      const examFilterStore = useExamFilterStore()
      const currentTopLevelFilter = examFilterStore.filter
      const currentInnerFilter = currentTopLevelFilter.filter

      if (filterKey === 'all') {
        this.hasFilterItems = false
        examFilterStore.reset()
        examFilterStore.refreshFilter({ newRequest: true })
        return
      }

      let filterUpdates = { ...currentInnerFilter };
      let updatedProperties = { ...(currentInnerFilter.properties || {}) };

      switch (filterKey) {
        case 'name':
          filterUpdates.patientID = null
          filterUpdates.patientFullName = null
          break
        case 'date':
          filterUpdates.startDate = null
          filterUpdates.endDate = null
        break;
        case 'reportStatus':
          filterUpdates.reportStatusFilter = 'all'
        break;
        case 'ffs':
          filterUpdates.ffsFilter = 'all'
        break;
        case 'mcRas':
        case 'color':
        case 'redfree':
        case 'infrared':
        case 'segAnterior':
        case 'panoramic':
        case 'stereo':
        case 'eyermaps':
          updatedProperties[filterKey] = false
          filterUpdates.properties = updatedProperties
        break
        default:
         console.warn(`Unknown filter item: ${filterKey}`)
         return
      }

      this.updateExamFilter({ filter: filterUpdates, newRequest: true })
    },
    clearSearch() {
      this.searchValue = ''
      this.showLatestResults = false
      this.showPatientSearchResults = false
      this.showDateFilter = false
      this.patientList = {}
      this.isExpanded = false
      this.searchMode = 'patient'
    },
    async showAllSearchedPatients() {
      const ok = await this.$refs.patientListSearchedOffcanvas.show({
        patientName: this.searchValue,
      })
      if (ok) {
        this.doFilterExamListByPatientID(ok)
      }
    },
    toggleExpandSearch() {
      this.isExpanded = !this.isExpanded;
    },
    toggleSearchMode() {
      this.isExpanded = true

      if (this.isSpecialist) {
        if (this.searchMode === 'exam') {
          this.toggleExamFilter()
        } else {
          this.searchMode = 'exam';
          this.showDateFilter = true;
          this.searchValue = '';
          this.showLatestResults = false;
          this.showPatientSearchResults = false;
        }
      } else {
        this.searchMode = this.searchMode === 'patient' ? 'exam' : 'patient';
        this.searchValue = '';
        this.showLatestResults = false;
        this.showPatientSearchResults = false;
        this.showDateFilter = (this.searchMode === 'exam');
      }
    },
    handleInputClick() {
      if (Object.keys(this.patientList).length > 0) {
        return
      }

      this.isExpanded = true;
      this.searchMode = 'patient';
      // this.showLatestResults = true;
      this.showPatientSearchResults = false;
      this.showDateFilter = false;
    },
    closeMenu() {
      document.getElementById('checkboxMenuToggle').click()
    }
  }
}
